<template>
  <Page title="Memberships" subpage>
    <template #actions>
      <div class="d-flex align-items-center">
        <ToggleSwitch
          v-model="active"
          label-on="Active"
          label-off="All"
          class="mr-3"
        />
        <Button
          icon="far fa-plus"
          text="Add Membership"
          @click="handleNewMembership"
        ></Button>
      </div>
    </template>
    <MembershipProgramsList :active="active" />
  </Page>
</template>

<script>
import { mapActions } from "vuex";

import Button from "@/components/Button.vue";
import Page from "@/components/Page.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import MembershipProgramsList from "./MembershipProgramsList.vue";
export default {
  components: {
    Page,
    Button,
    ToggleSwitch,
    MembershipProgramsList
  },
  data() {
    return {
      active: true
    };
  },
  mounted() {
    this.fetchPriceSheets();
  },
  methods: {
    ...mapActions(["fetchPriceSheets", "clearCurrentMembershipProgram"]),
    handleNewMembership() {
      this.clearCurrentMembershipProgram();
      this.$router.push(this.membershipProgramNewPath());
    }
  }
};
</script>

<style lang="scss" scoped></style>
